import { useState } from "react";
import Spinner from "../Spinner";
import Alert from "@mui/material/Alert";
import { doLogout } from "../../Utilities";

export default function LogoutButton() {
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);

  return (
    <>
      <Spinner visibility={spinnerVisibility} />
      <div className="flex flex-wrap absolute top-5 right-3 sm:right-8 font-skyMedium text-m md:text-xl text-white">
        <a
          href="#logout"
          title="Logout"
          className="logout-button"
          onClick={() =>
            doLogout(setAlertMessage, setShowAlert, setSpinnerVisibility)
          }
        >
          LOGOUT
        </a>
      </div>
      <Alert
        severity="error"
        style={{
          display: showAlert ? "flex" : "none",
        }}
      >
        {alertMessage}
      </Alert>
    </>
  );
}
